import AttributeDetailHeader from './AttributeDetailHeader';
import ControlsSection from './ControlsSection';
import TypeSection from './TypeSection';

const AttributeDetail = () => {
  return (
    <>
      <AttributeDetailHeader />
      <TypeSection />
      <ControlsSection />
    </>
  );
};

export default AttributeDetail;
